import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "antd/dist/reset.css";
import "./i18n"; // Import i18n configuration
import { ConfigProvider, Spin } from "antd";
import { antdSelectDefaults } from "./config/antdComponentDefaults";

// Loading component for suspense fallback
const Loader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Spin size="large" />
  </div>
);

// PostHog is configured inside App.tsx via getPostHogConfig() so a valid API key from .env is used when present.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <ConfigProvider select={antdSelectDefaults}>
    <Suspense fallback={<Loader />}>
      <App />
    </Suspense>
  </ConfigProvider>
);
